import * as React from 'react';
import { forwardRef } from 'react';
const Blik = (props, ref) => {
    const prefixId = React.useId();
    return (React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props },
        React.createElement("g", { clipPath: `url(#$${prefixId}__clip0_3558_51)` },
            React.createElement("path", { fill: `url(#$${prefixId}__paint0_linear_3558_51)`, d: "M0 0h40v40H0z" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.6 8.6H13v15.6a7.8 7.8 0 1 0 3.6-6.574V8.6Zm7.8 15.6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0Z", fill: "#fff" }),
            React.createElement("rect", { x: 20.8, y: 15.2, width: 7.2, height: 7.2, rx: 3.6, transform: "rotate(-90 20.8 15.2)", fill: `url(#$${prefixId}__paint1_linear_3558_51)` })),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: `$${prefixId}__paint0_linear_3558_51`, x1: 20, y1: 39.72, x2: 20, y2: 0.16, gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#5A5A5A" }),
                React.createElement("stop", { offset: 0.146, stopColor: "#484848" }),
                React.createElement("stop", { offset: 0.52, stopColor: "#212121" }),
                React.createElement("stop", { offset: 0.817, stopColor: "#080808" }),
                React.createElement("stop", { offset: 1 })),
            React.createElement("linearGradient", { id: `$${prefixId}__paint1_linear_3558_51`, x1: 21.858, y1: 16.251, x2: 26.949, y2: 21.349, gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#E52F08" }),
                React.createElement("stop", { offset: 1, stopColor: "#E94F96" })),
            React.createElement("clipPath", { id: `$${prefixId}__clip0_3558_51` },
                React.createElement("rect", { width: 40, height: 40, rx: 10, fill: "#fff" })))));
};
const ForwardRef = forwardRef(Blik);
export default ForwardRef;
ForwardRef.displayName = 'Blik';
//# sourceMappingURL=Blik.js.map